<template><div><h1 id="auftrag-archiviert" tabindex="-1"><a class="header-anchor" href="#auftrag-archiviert"><span>Auftrag, archiviert</span></a></h1>
<p>Auftrag, archiviert — Ein archivierter Versandhandelsauftrag</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Um die Fakturierung nicht unnötig zu belasten, können alte, abgeschlossene Aufträge aus dem System ausgelagert werden. Dies geschieht mittels regelmässig laufender Hintergrundjobs.</p>
<p>Der eigentliche Inhalt eines Auftrags, nämlich welche Ware geliefert worden ist, befindet sich in den <RouteLink to="/referenz/refs/ft.refdata.aufposhist.html" title="Auftragsposition, archiviert">Auftragspositionen, archiviert</RouteLink>.</p>
<p>Pfad: <code v-pre>Verkauf → Aufträge (archivierte)</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Auftragsnummer</dt>
<dd>Auftragsnummer, eindeutig, vom System automatisch vergeben.</dd>
<dt>Auftraggeber</dt>
<dd>Personen-ID des Auftraggebers (Rechnungsempfänger).</dd>
<dt>Status</dt>
<dd>Auftragsstatus. Folgende Auftragsstati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>Auftrag erfasst</td>
</tr>
<tr>
<td>4</td>
<td>Status 4 bezeichnet Aufträge, die nicht mehr in die Fakturierung kommen. Die Gründe können sein:Vollständig retournierter AuftragVollständig abgesagter AuftragErfolgreich fakturierter Auftrag mit Vorauszahlung</td>
</tr>
<tr>
<td>5</td>
<td>Fakturierung erfolgreich (zumindest teilweise geliefert)</td>
</tr>
</tbody>
</table>
</dd>
<dt>Lieferadresse</dt>
<dd>Personen-ID des Lieferungsempfängers.</dd>
<dt>Auftragsart</dt>
<dd>Die Auftragsart ist einer der wichtigsten Parameter des Auftrags. Sie kann aus <a class="xref" href="ft.refdata.tblaufart.html" title="Auftragsart"><span class="refentrytitle">Auftragsart</span></a> gewählt werden. Sie steuert u.a. aus welchem Lager die Waren geliefert werden, welche Formulare für die Lieferscheine und Rechnungen gebraucht werden, welche Währungen für den Auftrag möglich sind, welches Porto berechnet wird, etc.</dd>
<dt>verarbeiten ab</dt>
<dd>Verarbeitungsdatum des Auftrags: Der Auftrag wird erst ab diesem Datum im System ausgelöst.</dd>
<dt>Bestellart</dt>
<dd>Die <a class="link" href="ft.refdata.tblbest.html" title="Bestellarten">Bestellart</a> sagt aus, auf welche Art und Weise bestellt wurde (per Fax, telefonisch, etc.).</dd>
<dt>MWST</dt>
<dd>MWST-Berechnung: Die Standardeinstellung <span class="guilabel">.</span> bedeutet, dass die MWST mit gerechnet wird und <span class="guilabel">Exp</span> bedeutet, dass keine MWST berechnet wird (für Exportaufträge).</dd>
</dl>
<div class="hint-container tip">
<p class="hint-container-title">Tipp</p>
<p>Das System verhindert die Eingabe von <span class="guilabel">Exp</span> für einen inländischen Auftraggeber (Land ist <span class="guilabel">CH</span> oder leer). Falls z.B. für ausl. Botschaften doch ein Auftrag ohne MWST erfasst werden soll, kann in der Adresse im Feld Land ein Punkt eingegeben werden, um diese Validierung zu umgehen.</p>
</div>
<dl>
<dt>Verarbeitungssart</dt>
<dd>Die <a class="link" href="ft.refdata.tblverarb.html" title="Verarbeitungsarten">Verarbeitungsart</a> steuert i.a., ob es sich um einen Expressversand, Schnellversand oder einen Normalversand handelt.</dd>
<dt>Vorauszahlung</dt>
<dd>Die folgenden Vorauszahlungsstati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>nein</td>
<td>Keine Vorauszahlung; die Ware wird gegen Rechnung geliefert. (Standardeinstellung)</td>
</tr>
<tr>
<td>ja</td>
<td>Vorauszahlung verlangt. Die Lieferung erfolgt erst nach Eingang des Vorauszahlungsbetrages. Das System erstellt zuerst eine Rechnung über den Auftragsbetrag.</td>
</tr>
<tr>
<td>ist bezahlt</td>
<td>Vorauszahlungsbetrag eingegangen. Der Status bedeutet, dass der Auftrag nun geliefert werden kann.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Vorauszahlungsbetrag</dt>
<dd>Dieser Betrag wird als Vorauszahlung verlangt und in Rechnung gestellt. Wird hier 0 eingegeben, dann muss der volle Auftragswert vorausbezahlt werden.<br>Dieses Feld kann nur editiert werden wenn der Vorauszahlungsstatus auf <span class="guilabel">ja</span> gesetzt ist.</dd>
<dt>Teillieferung</dt>
<dd>Teillieferungsschalter. Standardmässig wird die Teillieferung nach den Einstellungen in den <a class="link" href="ft.refdata.tblgeduld.html" title="Geduldstufen">Geduldstufen</a> ausgelöst. Mit <span class="guilabel">sofort</span> wird bei der nächsten Fakturierung eine Teillieferung erzwungen (wenn mindestens eine Position lieferbar ist). Nach dem Fakturalauf wird der Schalter wieder auf <span class="guilabel">nach Geduldstufen</span> gesetzt.</dd>
<dt>Geduldstufe</dt>
<dd>Anzeige der <a class="link" href="ft.refdata.tblgeduld.html" title="Geduldstufen">Geduldstufe.</a></dd>
<dt>Ordertyp (kein Label)</dt>
<dd>Der <a class="link" href="ft.refdata.tblordertypwv.html" title="Ordertypen Wiederverkäufer">Ordertyp</a> kann nur editiert werden wenn dieser in der Tabelle <a class="link" href="ft.refdata.tblaufart.html" title="Auftragsart">Auftragsarten</a> freigeschaltet und ein Eintrag in der Ordertyp-Tabelle vorhanden ist.</dd>
<dt>Spende</dt>
<dd>Betrag der (optional) versprochenen Spende. Für jede Spende wird ein sog. &quot;Spendenartikel (fiktiver Artikel mit typ &quot;Spende&quot;) einefügt. Wird der Spendenbetrag in dieses Feld geschrieben, wird der Stanard-Spendenartikel aus der Auftragsart eingetragen. Alterantiv können beliebige Spendenartinkel als Auftragsposition erfasst werden.</dd>
<dt>&quot;WBS-Text vorhanden&quot;</dt>
<dd>Dieser Text weist darauf hin, dass ein <a class="link" href="ft.refdata.tblwbsinfo.html" title="WBS-Infotext">WBS-Infoext</a> erfasst worden ist</dd>
<dt>Versandkosten</dt>
<dd>Anzeige der Versandkosten des Auftrags. Die Versandkosten sind parallel in einer Auftragsposition mit einem Porto-Artikel erfasst. Änderungen an den Versandkosten im Auftragskopf ändern die Porto-Position und umgekehrt.</dd>
<dt>&quot;DLS-Text vorhanden&quot;</dt>
<dd>Dieser Text weist darauf hin, dass ein Direktlieferschein-Text erfasst worden ist</dd>
<dt>Total</dt>
<dd>Gesamttotal der Rechnung, zusammengesetzt aus Total aller Artikelpositionen, Versandkosten und versprochener Spende.</dd>
</dl>
<div class="hint-container warning">
<p class="hint-container-title">Wichtig</p>
<p>Abgesagte Positionen (Status <span class="guilabel">A</span>) werden hier immer noch summiert, hingegen Retourpositionen (Status <span class="guilabel">R</span>) werden abgezogen.</p>
</div>
<dl>
<dt>Währung</dt>
<dd><a class="link" href="ft.refdata.whg.html" title="Währung">Währungscode</a> der Auftragswährung. Alle Beträge des Auftrags (und seiner Positionen) sind in dieser Währung zu verstehen.</dd>
<dt>Info</dt>
<dd>Informationstext für interne Zwecke. Dieser Text wird nicht auf die Rechnung gedruckt.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="drucken-auftragsliste" tabindex="-1"><a class="header-anchor" href="#drucken-auftragsliste"><span>Drucken (Auftragsliste)</span></a></h3>
<p>Druckt eine Liste mit Auftragszeilen.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


